
<div>
  <collapsible-section
      :id="`objectModelRelationCollapse-${relation.client_id}-${inverse ? 'inverse' : null}-${level}-${dropdownControlId}`"
      control-name="objectModelRelationCollapse"
      :is-open="isOpen(handler.hasRelatedObjectModelMatch(lowerQ, relation))"
      :disabled="relationIsDisabled(relation)"
  >
    <template #section-header>
      <row
        v-tooltip="tooltipMessage(relation)"
      >
        <prefix>
          <icon glyph="object-model"/>
        </prefix>
        <column>
          {{ relation.friendlyDescriptionFor(inverse) }}
        </column>
      </row>
    </template>
    <!--          Don't try to render this section if relation button is disabled-->
    <template #section-contents v-if="!relationIsDisabled(relation)">
      <div
          v-for="relatedOM in relation.relatedObjectModelsFor(inverse)"
          :key="`${relation.client_id}-${inverse ? 'inverse' : null}-${relatedOM.client_id}-${dropdownControlId}`"
      >
        <collapsible-section
            :id="`objectModelRelatedObjectModelCollapse-${relation.client_id}-${inverse ? 'inverse' : null}-${relatedOM.client_id}-${level}-${dropdownControlId}`"
            control-name="objectModelRelatedObjectModelCollapse"
            :is-open="isOpen(handler.hasObjectModelDataMatch(lowerQ, relatedOM))"
        >
          <template #section-header>
            {{ relatedOM.titleOrDefault }}
          </template>
          <template #section-contents>
            <slot></slot>

            <section-fields
              v-if="handler.usersOnly"
              :q="q"
              :handler="handler"
              :section="handler.userSection(relatedOM)"
              icon-glyph="member"
              @select="select"
              :select-additional-parameters="[continuePathFor(relation, relatedOM)]"
            />

            <template v-if="!handler.usersOnly">
              <object-model-property-data
                v-if="!handler.hideProperties"
                :handler="handler"
                :q="q"
                :object-model="relatedOM"
                :level="level + 1"
                default-open
                :path="continuePathFor(relation, relatedOM)"
                :parent-tree-context="childTreeContextWithRelation(relation)"
                @select="select"
              ></object-model-property-data>
              <object-model-record-metadata-data
                v-if="handler.showRecordMetaData"
                :handler="handler"
                :q="q"
                :object-model="relatedOM"
                :level="level + 1"
                default-open
                @select="select"
                :path="continuePathFor(relation, relatedOM)"
                :parent-tree-context="childTreeContextWithRelation(relation)"
              ></object-model-record-metadata-data>
            </template>

            <object-model-relationship-data
                v-if="level < 5 && handler.traverseRelatedObjectModels"
                :handler="handler"
                :q="q"
                :object-model="relatedOM"
                :level="level + 1"
                :path="continuePathFor(relation, relatedOM)"
                :parent-tree-context="childTreeContextWithRelation(relation)"
                @select="select"
            ></object-model-relationship-data>
          </template>
        </collapsible-section>
      </div>
    </template>
  </collapsible-section>
</div>
